module.exports = __webpack_public_path__ + "img/clickandcollectmarker.b038a51a.png";